import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query';
import { QuestionsService } from '../questions.service';

export const useGetQuestions = (
	options?: Omit<
		UseQueryOptions<Array<Questions.Question>, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['questions'],
		queryFn: () => QuestionsService.get(),
		refetchOnWindowFocus: false,
		...options,
	});
};
